import { createContext } from 'react'

import { CurrenciesContextType } from './CurrenciesContext.types'

export const CurrenciesContext = createContext<CurrenciesContextType | undefined>(undefined)
